export default __webpack_public_path__ + "682012c8dca584db9e5986cb15a73e30.png";